<div class="modal-body wrapper-modal main-container">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
  <div class="title">{{data?.title}}</div>
  <div class="py-1 px-2 col-12 alert mb-4 text-bold text-center" *ngIf="data?.inspect?.id" [ngClass]="{'warning-text': !utils.isDefined(data?.inspect?.approval),
              'success-text': data?.inspect?.approval,
              'danger-text': utils.isDefined(data?.inspect?.approval) && !data?.inspect?.approval
    }">
    <i class="fas"
      [ngClass]="{'fa-check-circle': data?.inspect?.approval, 'fa-exclamation-circle': !data?.inspect?.approval}"></i>
    {{utils.isDefined(data?.inspect?.approval)? data?.inspect?.approval ? 'Aprobado' : 'Rechazado' : 'Sin aprobar'}}
  </div>
  <form>
    <mat-card-content class="d-flex flex-wrap my-3">
      <div class="pl-0 col-md-6" *ngIf="approvalUserInformation">
        <label class="label-field">{{utils.isDefined(data?.inspect?.approval) && data?.inspect?.approval ? 'Aprobado' :
          'Rechazado'}} por:</label>
        <input type="text" class="form-control" [value]="approvalUserInformation" readonly>
      </div>
      <div class="pl-0 col-12" [ngClass]="{'col-md-6': approvalUserInformation}" *ngIf="createdUserInformation">
        <label class="label-field">
          {{type === 'form' ? 'Creado por:' : 'Subido por:'}}
        </label>
        <input type="text" class="form-control" [value]="createdUserInformation" readonly>
      </div>
    </mat-card-content>
  </form>
  <div *ngIf="canApproveInspection">
    <mat-form-field appearance="standard">
      <mat-label>Responsable de la aprobación/rechazo</mat-label>
      <input type="text" matInput [formControl]="approvalUserControl">
      <i *ngIf="!changeApprovalUser && type === 'document'" matSuffix matTooltip="Editar" matTooltipPosition="above"
        class="fas fa-pencil-alt cursor-pointer color-primary" (click)="setNewApprovalUser(true)"></i>
      <i *ngIf="changeApprovalUser" matSuffix matTooltip="Cancelar" matTooltipPosition="above"
        class="fas fa-times cursor-pointer cancel" (click)="setNewApprovalUser(false)"></i>
    </mat-form-field>
    <app-input-document-user *ngIf="changeApprovalUser" [inputFormControl]="changeApprovalUserControl"
      [options]="optionsDocumentUser">
    </app-input-document-user>
  </div>
  <div class="container-checklist">
    <form [formGroup]="form" class="mb-3" *ngIf="type === 'form'">
      <div class="row">
        <div class="col-md-12">
          <mat-form-field>
            <mat-label>Contenedor No<span class="asterisk">*</span></mat-label>
            <input matInput formControlName="container">
            <mat-error *ngIf="form.get('container').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Sello Indicativo<span class="asterisk">*</span></mat-label>
            <input matInput formControlName="indicativeSeal">
            <mat-error *ngIf="form.get('indicativeSeal').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Sello de Seguridad<span class="asterisk">*</span></mat-label>
            <input matInput formControlName="safetySeal">
            <mat-error *ngIf="form.get('safetySeal').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Patio<span class="asterisk">*</span></mat-label>
            <input matInput formControlName="courtyard">
            <mat-error *ngIf="form.get('courtyard').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Naviera<span class="asterisk">*</span></mat-label>
            <input matInput formControlName="shippingCompany">
            <mat-error *ngIf="form.get('shippingCompany').errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
    <!---->
    <app-inspection-document [inspectionType]="'container'" *ngIf="type === 'document'"
      [existingFileName]="data?.inspect?.inspectionDocument" [canUpload]="!data?.inspect?.id"
      [settings]="{ licensePlate: data?.licensePlate, cargoContainer: data?.cargoContainer, cargoId: data?.cargoId }"
      (fileSelected)="onFileSelected($event)">
    </app-inspection-document>

    <div class="opcion-decription" *ngIf="type === 'form'">
      <div *ngFor="let kvoption of options | keyvalue:originalOrder">{{kvoption.key}} = {{kvoption.value}} </div>
    </div>
    <mat-card-content class="container-options" *ngIf="type === 'form'">
      <div class="content-form" *ngFor="let element of checkLists; let i = index;">
        <label class="label-field font">
          {{checkListsMap[element.question]}}
        </label>
        <mat-radio-group class="radio-group" [(ngModel)]="element.response">
          <mat-radio-button *ngFor=" let option of options | keyvalue:originalOrder" [value]="option.key"
            [disabled]="!!data?.inspect?.id">
            {{option.key}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </mat-card-content>
    <mat-card-content *ngIf="type === 'form'">
      <div class="content-form">
        <label class="label-field font">
          ¿La unidad escogida presenta alguna alteración física?
        </label>
        <form [formGroup]="form">
          <mat-radio-group class="radio-group" formControlName="altered">
            <mat-radio-button [value]="true" [disabled]="!!data?.inspect?.id">Sí</mat-radio-button>
            <mat-radio-button [value]="false" [disabled]="!!data?.inspect?.id">No</mat-radio-button>
          </mat-radio-group>
        </form>
      </div>
    </mat-card-content>
    <mat-card-content class="container-options" *ngIf="type === 'form'">
      <div class="content-form">
        <label class="label-field font">
          Tamaño
        </label>
        <mat-radio-group class="radio-group" [(ngModel)]="tmpsize">
          <mat-radio-button [value]="20" [disabled]="!!data?.inspect?.id">20"</mat-radio-button>
          <mat-radio-button [value]="40" [disabled]="!!data?.inspect?.id">40"</mat-radio-button>
          <mat-radio-button [value]="-1" [disabled]="!!data?.inspect?.id">Otro</mat-radio-button>
        </mat-radio-group>

        <form [formGroup]="form">
          <mat-form-field appearance="standard" [hidden]="tmpsize !== -1">
            <mat-label>¿Cual?</mat-label>
            <input type="number" matInput min="1" step="1"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57" name="size" formControlName="size" />
          </mat-form-field>
        </form>
      </div>
    </mat-card-content>
    <mat-card-content class="container-options" *ngIf="type === 'form'">
      <div class="content-form">
        <label class="label-field font">
          Clase
        </label>
        <form [formGroup]="form">
          <mat-radio-group class="radio-group" formControlName="classType">
            <mat-radio-button *ngFor=" let option of classTypes | keyvalue:originalOrder" [value]="option.key"
              [disabled]="!!data?.inspect?.id">
              {{option.value}}
            </mat-radio-button>
          </mat-radio-group>
        </form>
      </div>
    </mat-card-content>
    <div *ngIf="containerStatus.length > 0 && type === 'form'">
      <hr>
      <h3>Estado del contenedor</h3>
      <div class="row" *ngFor="let status of containerStatus">
        <div class="col">
          <div class="row damangeRegister">
            <div class="col-md-4"><b>Ubicación:</b> {{status.containerLocation}}</div>
            <div class="col-md-4"><b>Tipo:</b> {{status.damageType}}</div>
            <div class="col-md-4"><b>Dimensión:</b> {{status.damageDimension}}</div>
            <div class="col-12"><b>Observación:</b> {{status.damageObs}}</div>
          </div>
        </div>
      </div>
    </div>
    <form #formDirective="ngForm" [formGroup]="damageForm" class="row align-items-center"
      (submit)="AttachDamangeObs(formDirective)" *ngIf="!data?.inspect?.id && type === 'form'">
      <mat-form-field class="col-md-4" appearance="standard">
        <mat-label>Ubicación</mat-label>
        <mat-select name="containerLocation" formControlName="containerLocation">
          <mat-option *ngFor="let damageOption of containerLocationDamageOptions" [value]="damageOption">
            {{ damageOption }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="damageForm.get('containerLocation').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="standard">
        <mat-label>Tipo de Daño</mat-label>
        <mat-select matNativeControl name="damangeType" formControlName="damageType">
          <mat-option *ngFor="let damageTypeOption of damageTypeOptions" [value]="damageTypeOption.value">{{
            damageTypeOption.label }}</mat-option>
        </mat-select>
        <mat-error *ngIf="damageForm.get('damageType').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="col-md-4" appearance="standard">
        <mat-label>Dimensiones</mat-label>
        <input type="text" matInput name="damangeDimension" formControlName="damageDimension" />
        <mat-error *ngIf="damageForm.get('damageDimension').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
      <figure class="col-md-12 mt-2">
        <img src="../../../../assets/img/container-inspection-damage.png" width="100%">
      </figure>
      <mat-form-field class="col-md-12 mb-2" appearance="outline">
        <mat-label>Observaciones del daño</mat-label>
        <textarea matInput name="damangeObs" formControlName="damageObs"></textarea>
        <mat-error *ngIf="damageForm.get('damageObs').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
        <mat-error *ngIf="damageForm.get('damageObs').errors?.minlength">
          {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'observaciones', 8) }}
        </mat-error>
      </mat-form-field>
      <div class="col-12 text-center">
        <button mat-raised-button color="primary" class="button-width-auto" type="submit">Agregar Daño</button>
      </div>
    </form>
    <hr>
    <form class="row form_container" [formGroup]="form" *ngIf="type === 'form'">
      <mat-form-field class="col-md-12" appearance="outline">
        <mat-label>Observación<span class="asterisk">*</span></mat-label>
        <textarea matInput formControlName="evaluatorObservation"></textarea>
        <mat-error *ngIf="form.get('evaluatorObservation').errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
        <mat-error *ngIf="form.get('evaluatorObservation').errors?.minlength">
          {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'observaciones', 8) }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  <!-- Btn-->
  <mat-card-actions>
    <button mat-raised-button color="primary" *ngIf="data?.inspect?.id" class="button-width-auto"
      (click)="downloadInspection()">
      Descargar
    </button>
    <button mat-raised-button color="primary" *ngIf="!data?.inspect?.id" class="button-width-auto"
      (click)="saveInspection()">
      Guardar
    </button>
    <button mat-raised-button color="primary" *ngIf="canRejectInspection" class="primary-secondary button-width-auto"
      (click)="confirmRejection()">
      Rechazar
    </button>
    <button mat-raised-button color="primary" *ngIf="canApproveInspection" class="button-width-auto"
      (click)="approve(true)">
      Aprobar
    </button>
  </mat-card-actions>
</div>